import React from 'react'
//import { sendRole } from '../../store/reducers/role.js'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withState, lifecycle, withHandlers } from 'recompose'
import { injectIntl, FormattedMessage } from 'react-intl'
import { fetchingState } from './../../helpers/hocs.js'
import { setRole } from '../../store/reducers/auth.js'
import { getUser } from '../../store/reducers/auth.js'


const nameOfRoles = {
    user: 'Я меценат',
    person: 'Я герой аукциона'
}

const ChooseRole = ({user, sendRoleToUser, onClose, Error=null, changeRole }) => (
    <div className='ChooseRole'>
        <h1 className='ChooseRole-title'>Вход</h1>
        <div className='role-items'>
            <div className='role-item' onClick={onClose}>{nameOfRoles.user}</div>
            {Object.keys(user.roles).map(role => (
                <div 
                    key={role}
                    value={role}
                    className='role-item'
                    onClick={(e) => sendRoleToUser(e)}
                >{nameOfRoles[role]}</div>
            ))}
        </div>
        {Error && <div className='ChooseRole-error' style={{marginTop: '15px'}}>Что-то пошло не так: нет соединения с сервером</div>}
    </div>
)

const mapStateToProps = (state) => ({})//состояние в этом компоненте не нужно поэтому возвращаем пустой объект
const mapDispatchToProps = dispatch => bindActionCreators({ setRole, getUser }, dispatch)

export default injectIntl(compose(
    fetchingState(),
    connect(mapStateToProps, mapDispatchToProps),
    withState('Error', 'setError', null),
    withHandlers({
        sendRoleToUser: ({Error, onClose, setRole, user, setError, changeRole, getUser}) => async (e) => {
            e && e.preventDefault();
            const role = e.target.getAttribute('value')
            const newRole = await setRole(role);
            if (newRole === 200) {
                //надо проверить - будет ли работать смена роли без этого метода (changeRole)
                //возможно без него не успеют обновиться роуты, поэтому оставляем
                changeRole(role);
                const userUpdate = await getUser();
                if (userUpdate === 200) {
                    if (Error) setError(null)
                    onClose();
                }
            } else setError(true);
        }
    }),
    lifecycle({
        componentWillUnmount () {
            if (this.props.Error) this.props.setError(null)
        },
      })
)(ChooseRole))



// WEBPACK FOOTER //
// ./src/components/Profile/ChooseRole.jsx